var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFillProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0146 5.59452C14.0146 8.65393 11.5616 11.1071 8.50002 11.1071C5.4395 11.1071 2.98545 8.65393 2.98545 5.59452C2.98545 2.53512 5.4395 0.0830078 8.50002 0.0830078C11.5616 0.0830078 14.0146 2.53512 14.0146 5.59452ZM8.50002 20.9163C3.98166 20.9163 0.166687 20.182 0.166687 17.3486C0.166687 14.5142 4.00563 13.8059 8.50002 13.8059C13.0194 13.8059 16.8334 14.5402 16.8334 17.3736C16.8334 20.208 12.9944 20.9163 8.50002 20.9163Z",
    fill: "#297037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillProfile);
export default __webpack_public_path__ + "static/media/FillProfile.4c03a40172d7814ce4ffa420be00c084.svg";
export { ForwardRef as ReactComponent };